/**
 * Organization Templates API
 *
 * RTK Query API wrapper for organization template management.
 * Provides cache tagging for automatic invalidation.
 */

import { enhancedApi } from '@store/generated/templates';

const ORG_TEMPLATES_TAG_TYPES = ['OrgTemplateList', 'TemplateList', 'Template'] as const;

export const orgTemplatesApi = enhancedApi.enhanceEndpoints({
  addTagTypes: ORG_TEMPLATES_TAG_TYPES,
  endpoints: {
    // List organization templates
    getV2ProviderNotetemplatesOrganization: {
      providesTags: result =>
        result?.templates
          ? [
              ...result.templates.map(t => ({
                type: 'Template' as const,
                id: t.id,
              })),
              { type: 'OrgTemplateList' as const, id: 'LIST' },
            ]
          : [{ type: 'OrgTemplateList' as const, id: 'LIST' }],
    },

    // Create organization template
    postV2ProviderNotetemplatesOrganization: {
      invalidatesTags: [{ type: 'OrgTemplateList', id: 'LIST' }],
    },

    // Convert user template to organization template
    postV2ProviderNotetemplatesOrganizationConvert: {
      invalidatesTags: (_result, _error, { convertToOrgTemplateRequest }) => [
        { type: 'OrgTemplateList', id: 'LIST' },
        { type: 'TemplateList', id: 'LIST' },
        { type: 'Template', id: convertToOrgTemplateRequest.template_id },
      ],
    },
  },
});

export const {
  useGetV2ProviderNotetemplatesOrganizationQuery: useGetOrgTemplatesQuery,
  useLazyGetV2ProviderNotetemplatesOrganizationQuery: useLazyGetOrgTemplatesQuery,
  usePostV2ProviderNotetemplatesOrganizationMutation: useCreateOrgTemplateMutation,
  usePostV2ProviderNotetemplatesOrganizationConvertMutation: useConvertToOrgTemplateMutation,
} = orgTemplatesApi;
